// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Afidium
import { SimpleTextareaFieldWithVariablesComponent } from './simple-textarea-field-with-variables.component';
import { SimpleTextareaFieldModule } from '../simple-textarea-field/simple-textarea-field.module';
import { VariablesHelpModule } from '../../../../component/variablesHelp/variablesHelp.module';

@NgModule({
    declarations: [
        SimpleTextareaFieldWithVariablesComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SimpleTextareaFieldModule,
        VariablesHelpModule,
    ],
    exports: [
        SimpleTextareaFieldWithVariablesComponent,
    ]
})
export class SimpleTextareaFieldWithVariablesModule {}